/**
 * @file 绑定信用卡
 * @date 2020/07/28
 */

import React, {Component} from 'react';
import NavBarComponent from '../../component/common/NavBarComponent';
import {NavBar, WingBlank, Button, List, InputItem, Toast, Icon} from 'antd-mobile';
import storage from 'store';
import {parseStateToSearch, parseSearchToState} from '../../util/util.js';
import {Http, urls} from '../../api/index';
import './index.scss';

class BindCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardNum: '',
            user: {
                name: ''
            }
        };
    }

    componentDidMount() {
        this.getUserInfo();
    }

    getUserInfo() {
        setTimeout(() => {
            Http.post({url: '/api/user/personalInfo.json'}).then(res => {
                this.setState({
                    user: {
                        name: storage.get('user').name
                    }
                });
            });
        }, 600);
    }

    onChangeCardNum(val) {
        this.setState({
            cardNum: val
        });
    }

    /**
     *
     * 校验输入的卡号是否为正确的信用卡卡号
     * @param {number} s 输入的卡号
     *
     */
    validateCreditCard(s) {
        // remove non-numerics
        let v = '0123456789';
        let w = '';
        let i = '';
        let j = '';
        let k = '';
        let m = '';
        let c = '';
        let a = '';
        let x = '';

        for (i = 0; i < s.length; i++) {
            x = s.charAt(i);

            if (v.indexOf(x, 0) !== -1) {
                w += x;
            }
        }
        // validate number
        j = w.length / 2;
        k = Math.floor(j);
        m = Math.ceil(j) - k;
        c = 0;

        for (i = 0; i < k; i++) {
            a = w.charAt(i * 2 + m) * 2;
            c += a > 9 ? Math.floor(a / 10 + a % 10) : a;
        }

        for (i = 0; i < k + m; i++) {
            c += w.charAt(i * 2 + 1 - m) * 1;
        }

        return c % 10 === 0;
    }

    submitinfo() {
        if (!this.validateCreditCard(this.state.cardNum)) {
            return Toast.info('请输入正确的信用卡卡号！', 3, null, false);
        }
        Http.post({url: '/api/cardBinConfig/findMessageByCardNo', data: {
            cardNo: this.state.cardNum
        }}).then(res => {
            let data = res.data;
            if (data.cardType !== 'CREDIT_CARD') {
                Toast.info('请输入信用卡卡号！', 3, null, false);
            }
            else {
                this.props.history.push({
                    pathname: '/addCard',
                    search: parseStateToSearch({cardNum: this.state.cardNum})
                });
            }
        });
    }

    render() {
        return (
            <div id="bind-card" className="page">
                <NavBarComponent>
                    <NavBar
                        icon={<Icon type="left" color='#333' />}
                        onLeftClick={() => {this.props.history.push('/my');}}
                        mode='light'>
                        信用卡
                    </NavBar>
                </NavBarComponent>
                <WingBlank>
                    <div className="page-section user-tips">
                        <span className="text">请绑定 </span>
                        {
                            this.state.user.name
                            ? this.state.user.name
                            : <span className="text">您</span>
                        }
                        <span className="text"> 的信用卡</span>
                    </div>
                    <div className="page-section">
                        <List>
                        <InputItem
                            className="input_card"
                            type="number"
                            maxLength="19"
                            value={this.state.cardNum}
                            onChange={e => {this.onChangeCardNum(e);}}
                            placeholder="请输入信用卡号" />
                        </List>
                    </div>
                    <div className="page-section">
                        <Button
                            disabled={this.state.cardNum.length < 13 || this.state.cardNum.length > 19}
                            type="warning"
                            onClick={e => {this.submitinfo(e);}}>
                            下一步
                        </Button>
                    </div>
                </WingBlank>
            </div>
        );
    }
}

export default BindCard;